export const fetchRecords = () => ({
  method: 'GET',
  url: '/records'
});

export const fetchRecord = recordId => ({
  method: 'GET',
  url: `/records/${recordId}`
});

export const createRecord = data => ({
  method: 'POST',
  url: '/records',
  data
});

export const updateRecord = data => ({
  method: 'PUT',
  url: `/records/${data._id}`,
  data
});

export const createEvent = (recordId, data) => ({
  method: 'POST',
  url: `/records/${recordId}/event`,
  data
})

export const updateEvent = (recordId, data) => ({
  method: 'PUT',
  url: `/records/${recordId}/event/${data._id}`,
  data
})

export const deleteRecord = recordId => ({
  method: 'DELETE',
  url: `/records/${recordId}`
});

export const createProperty = (data) => ({
  method: 'POST',
  url: `/records/${data.recordId}/property`,
  data
});

export const updateProperty = (data) => ({
  method: 'PUT',
  url: `/records/${data.recordId}/property/${data.propertyId}`,
  data: { value: data.value }
});

export const deleteProperty = (data) => ({
  method: 'DELETE',
  url: `/records/${data.recordId}/property/${data.propertyId}`
});
